import { normalizeEventPerformanceTypeForThread } from './eventThreadMetaUtils';

const toSafeNumber = (value, fallback = 0) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

export const mapRowsByEventUuid = (rows = []) => {
  const list = Array.isArray(rows) ? rows : [];
  return new Map(
    list
      .map((row) => {
        const eventUuid = String(row?.event_uuid || '').trim();
        if (!eventUuid) return null;
        return [eventUuid, row];
      })
      .filter(Boolean)
  );
};

export const composeAdminEventRowWithDetail = ({
  eventRow,
  detail,
  originalDetail = null,
  unreadCount = null,
} = {}) => {
  const base = eventRow && typeof eventRow === 'object' ? eventRow : {};
  const d = detail && typeof detail === 'object' ? detail : null;
  if (!d) {
    const mergedBase =
      unreadCount == null ? { ...base } : { ...base, unreadCount: toSafeNumber(unreadCount, 0) };
    mergedBase.performance_type = normalizeEventPerformanceTypeForThread(
      mergedBase,
      mergedBase.performance_type
    );
    return mergedBase;
  }

  let flyer = d.flyer_front_url;
  if (
    d.performance_flag === 'additional' &&
    d.use_existing_flyers &&
    d.original_event_uuid
  ) {
    flyer = originalDetail?.flyer_front_url || flyer;
  }

  const merged = {
    ...base,
    flyer_front_url: flyer,
    performance_flag: d.performance_flag,
    use_existing_flyers: d.use_existing_flyers,
    original_event_uuid: d.original_event_uuid,
    assigned_admins:
      d.assigned_admins || d.assignedAdmins || d.assigned_admin_users,
  };
  merged.performance_type = normalizeEventPerformanceTypeForThread(
    merged,
    d.performance_type
  );
  if (unreadCount != null) {
    merged.unreadCount = toSafeNumber(unreadCount, 0);
  }
  return merged;
};

export const composeArtistEventRowWithComposite = ({
  eventRow,
  compositeRow,
  unreadCount = 0,
  preferEventPerformanceType = false,
} = {}) => {
  const base = eventRow && typeof eventRow === 'object' ? eventRow : {};
  const composite = compositeRow && typeof compositeRow === 'object'
    ? compositeRow
    : {};

  const performanceType = preferEventPerformanceType
    ? base.performance_type ?? composite.performance_type
    : composite.performance_type ?? base.performance_type;

  const merged = {
    ...base,
    flyer_front_url: composite.flyer_front_url,
    name: base.name ?? composite.name,
    unreadCount: toSafeNumber(unreadCount, 0),
  };
  merged.performance_type = normalizeEventPerformanceTypeForThread(
    merged,
    performanceType
  );
  return merged;
};
